import React from 'react';
import { VStack, Heading, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card';
import PolicyCard from './PolicyCard';
import BillingCard from './BillingCard';
import ListedDriversCard from './ListedDriversCard';
import ListedVehiclesCard from './ListedVehiclesCard';

interface UploadSummaryCardProps {
  sectionData: any;
}

const UploadSummaryCard: React.FC<UploadSummaryCardProps> = ({
  sectionData,
}) => {
  const bgColor = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');

  if (!sectionData) return null;

  return (
    <Card bg={bgColor} p={6} borderColor={borderColor} borderWidth="1px">
      <VStack spacing={6} align="stretch">
        <Heading size="md" color={textColor}>
          Upload Summary
        </Heading>

        <VStack spacing={6} align="stretch">
          <PolicyCard sectionData={sectionData?.policy} />
          <BillingCard sectionData={sectionData?.billing} />
          <ListedDriversCard sectionData={sectionData?.listedDrivers} />
          <ListedVehiclesCard sectionData={sectionData?.listedVehicles} />
        </VStack>
      </VStack>
    </Card>
  );
};

export default UploadSummaryCard;
